import { Toaster } from "@/components/ui/toaster"
import { Toaster as Sonner } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { LoadingProvider } from "./contexts/LoadingContext"
import { RouterProvider } from "react-router-dom"
import { router } from "./routes"
import { SubscribeConfirmProvider } from "./modules/Events/context/SubscribeConfirmContext"
// import { useAppRedirect } from "./hooks/use-app-redirect"

const queryClient = new QueryClient()

const App = () => {
  // useAppRedirect()

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <LoadingProvider>
          <SubscribeConfirmProvider>
            <Toaster />
            <Sonner position="top-center" />
            <RouterProvider router={router} />
          </SubscribeConfirmProvider>
        </LoadingProvider>
      </TooltipProvider>
    </QueryClientProvider>
  )
}

export default App
